import * as moment from "moment-timezone";
import * as React from "react";
import { useMappedState } from "redux-react-hook";

import {
  getDeliveryWeekLeadTimes,
  getOrderMode
} from "src/core/drops/utils/inherited-settings";
import { IStore } from "src/core/shared/store/index";
import useAllowedLeadTimeGroups from "src/core/orders/hooks/validation/useAllowedLeadTimeGroups";
import { useDrop } from "src/core/drops/hooks";
import { ListProductsFilters } from "src/core/products/api/products.api";

const useProductSearchFilters = () => {
  const [ { drop } ] = useDrop();

  const {
    currentOrder, currentList, currentRole, installedModules
  } = useMappedState(({
    orders, global, lists
  }: IStore) => ({
    currentOrder: orders.currentOrder,
    currentList: lists.currentList,
    currentRole: global.role,
    installedModules: global.settings ? global.settings.installedModules || [] : []
  }));

  const getLeadTimeGroupsAllowed = useAllowedLeadTimeGroups();

  return React.useCallback(
    (showUnavailable = false) => {
      let dateLedOnly = false;

      if (drop) {
        const orderMode = getOrderMode(drop.groupedSettings);

        if (orderMode && orderMode.allow === "DL") {
          dateLedOnly = true;
        }
      }
      const currentOrderMode = currentOrder.data ? currentOrder.mode : currentList.mode;
      const newFilters: ListProductsFilters = {};
      const now = moment.utc().toDate();

      newFilters.published = true;

      if (drop && currentOrder.mode === "edit") {
        if (!showUnavailable) {
          const leadTimes = getDeliveryWeekLeadTimes(drop.groupedSettings);

          if (currentOrder.data && currentOrder.data.orderDeliveryDate && leadTimes) {
            const allowedCutoffDays = getLeadTimeGroupsAllowed(currentOrder.data.orderDeliveryDate);

            newFilters.leadTimeGroupId = allowedCutoffDays;
          }
        }
      } else {
        if (currentRole && currentRole.type === "admin") {
          delete newFilters.published;
        }
      }

      // if price change module then filter with effective date too
      if (installedModules.includes("price-change") && drop) {
        newFilters.branchId = drop.id;

        if (currentOrder.data?.orderDeliveryDate && currentOrderMode === "edit") {
          newFilters.effectiveDate = currentOrder.data.orderDeliveryDate || now;
        }
      } else if (drop) {
        // otherwise just use pricecodes
        newFilters.branchId = drop.id;
      }

      if ((currentOrder.data && currentOrder.data.orderDeliveryDate) || (currentList.data && currentList.data.schedule) || dateLedOnly) {
        newFilters.madeToOrder = false;
      }

      return newFilters;
    },
    [
      drop,
      currentOrder.data,
      currentOrder.mode,
      currentList.mode,
      currentList.data,
      installedModules,
      getLeadTimeGroupsAllowed,
      currentRole
    ]
  );
};

export default useProductSearchFilters;
